module.exports = __webpack_public_path__ + "img/potencia_a_blue.80684aa2.svg";